import actionTypes from '../../actionTypes';

const dev = false
const paid = false

const states = {
    // appKey: 'e0eecc466490211c35efe899fea6e704', // dev devshippingrates
    // appKey: '2251b13da983ab352acb53602ecc5c62', // test live
    appKey: '8c3cce34bdc5aeffbce6bc09d860dfa2', // live
    shopName: '',
    dev: dev,
    host: 'YWRtaW4uc2hvcGlmeS5jb20vc3RvcmUvYWhzYW4tdGVzdGluZw',
    phone: "923067733666",
    shop_id: dev ? "62441357502" : '',
    title: '',
    store: {},
    // free_shipping_rule: {},
    feedback: false,
    show_message: false,
    remainingTrial: 0,
    activePlan: {},
    features: [],
    paid: paid,
    payment_id: null,
    interval: null,
    currency: '',
    country: {},
    warning: null,
    statesList: [],
    countries: [],
    locations: [],
    toast: { active: false, content: '', error: false }
}
const ConfigReducer = (state = states, action) => {
    switch (action.type) {
        case actionTypes.setStore:
            return {
                ...state,
                store: action.payload
            }
        case actionTypes.payment:
            return {
                ...state,
                paid: action.payload
            }
        case actionTypes.setRemainingTrial:
            return {
                ...state,
                remainingTrial: action.payload
            }
        case actionTypes.setActivePlan:
            return {
                ...state,
                activePlan: action.payload
            }
        case actionTypes.setFeatures:
            return {
                ...state,
                features: action.payload
            }
        case actionTypes.paymentId:
            return {
                ...state,
                payment_id: action.payload
            }
        case actionTypes.setTitle:
            return {
                ...state,
                title: action.payload
            }
        case actionTypes.setPaymentInterval:
            return {
                ...state,
                interval: action.payload
            }
        case actionTypes.addShopName:
            return {
                ...state,
                shopName: action.payload
            }
        case actionTypes.saveCurrency:
            return {
                ...state,
                currency: action.payload
            }
        case actionTypes.ShowWarning:
            return {
                ...state,
                warning: action.payload
            }
        case actionTypes.ShowMessage:
            return {
                ...state,
                show_message: action.payload
            }
        case actionTypes.saveShopId:
            return {
                ...state,
                shop_id: action.payload
            }
        // case actionTypes.saveFreeShippingRule:
        //     return {
        //         ...state,
        //         free_shipping_rule: action.payload
        //     }
        case actionTypes.saveCountry:
            return {
                ...state,
                country: action.payload
            }
        case actionTypes.saveStatesList:
            return {
                ...state,
                statesList: action.payload
            }
        case actionTypes.saveCountries:
            return {
                ...state,
                countries: action.payload
            }
        case actionTypes.setLocations:
            return {
                ...state,
                locations: action.payload
            }
        case actionTypes.setToast:
            return {
                ...state,
                toast: action.payload
            }
        case actionTypes.setHost:
            return {
                ...state,
                host: action.payload
            }
        case actionTypes.setFeedback:
            return {
                ...state,
                feedback: action.payload
            }
        default:
            return state
    }
}

export default ConfigReducer